import { ProfileEndpoints } from './ProfileEndpoints';
import { UsersEndpoints } from './UsersEndpoints';
import { AccountsEndpoints } from './AccountsEndpoints';
import { CustomerEndpoints } from './CustomerEndpoints';
import type { Authentication } from "../auth/Authentication";

export class AccountServer {
    Profile: ProfileEndpoints;
    Users: UsersEndpoints;
    Accounts: AccountsEndpoints;
    Customer: CustomerEndpoints;

    constructor(auth: Authentication) {
        this.Profile = new ProfileEndpoints(auth);
        this.Users = new UsersEndpoints(auth);
        this.Accounts = new AccountsEndpoints(auth);
        this.Customer = new CustomerEndpoints(auth);
    }
}
